<div class="qr-code" nz-row nzJustify="space-between" [style.width]="relogin ? '377px' : '500px'">
  <nz-spin [nzSpinning]="loadingNewQr">
    <div class="qr-code__image-container">
      <ngx-kjua
        [renderAsync]="false"
        [render]="'svg'"
        [crisp]="true"
        [minVersion]="1"
        [ecLevel]="'L'"
        [size]="relogin ? 120 : 190"
        [fill]="'#333'"
        [back]="'#fff'"
        [rounded]="0"
        [quiet]="0"
        [mode]="'image'"
        [mSize]="relogin ? 90 : 100"
        [mPosX]="50"
        [mPosY]="50"
        [fontcolor]="'#ff9818'"
        [image]="bgQr"
        [cssClass]="'image-auto'"
        [text]="qrData"
        [style.opacity]="showRefreshBtn ? .2 : 1"
      ></ngx-kjua>

      <div [ngClass]="showRefreshBtn ? 'qr-code__refresh--visible' : 'qr-code__refresh--hidden'">
        <img class="qr-code__refresh--icon" src="assets/icons/refresh-filled/M.svg" alt="">
        <p class="qr-code__refresh--text" [translate]="'HOME.LOGIN_PAGE.QR_SECTION.BTN_REFRESH'">Обновить</p>
      </div>
    </div>
    <div class="qr-code__info">
      <div>
        <h5 class="qr-code__info--title" [translate]="'HOME.LOGIN_PAGE.QR_SECTION.TITLE'">Вход по QR-коду</h5>
        <div class="qr-code__info--desc" [innerHTML]="'HOME.LOGIN_PAGE.QR_SECTION.DESC' | translate">Отсканируйте
          QR-код в <br>мобильном приложении <br> <br><strong>BCC Business</strong>
        </div>
        <div *ngIf="timer;" class="qr-code__info--timer"><span
          [translate]="'HOME.LOGIN_PAGE.QR_SECTION.TIMER'">Срок действия кода: </span>{{timer | formatTime}}</div>
        <!--          <ng-template #timeout>
                    <div class="qr-code__info&#45;&#45;timeout" [translate]="'HOME.LOGIN_PAGE.QR_SECTION.TIMEOUT'">Срок действия кода
                      истек
                    </div>
                  </ng-template>-->
      </div>

      <div class="qr-code__info--help" (click)="isTooltipShown=!isTooltipShown">
        <span [translate]="'HOME.LOGIN_PAGE.QR_SECTION.HELP'">Как войти по QR-коду</span>
        <span class="logo"></span>
      </div>
    </div>
  </nz-spin>

  <ng-container>
    <div class="help-tooltip" [ngClass]="isTooltipShown ? 'help-tooltip--visible' : 'help-tooltip--hidden'">
      <p [innerHTML]="'HOME.LOGIN_PAGE.QR_SECTION.TOOLTIP_1' | translate">1. Откройте мобильное приложение <strong>BCC
        Business</strong></p>
      <p [innerHTML]="'HOME.LOGIN_PAGE.QR_SECTION.TOOLTIP_2' | translate">2. Выберите Профиль и нажмите <strong>BCC
        Business Web</strong></p>
      <p [innerHTML]="'HOME.LOGIN_PAGE.QR_SECTION.TOOLTIP_3' | translate">3. Наведите телефон на QR-код что-бы
        отсканировать</p>
    </div>
  </ng-container>
</div>
